import * as React from 'react';

/**
 * Hook to handle expanded items in rtkui accordion
 */
export const useOBAccordionChange = (items: string[]) => {
  const [expandedItems, setExpandedItems] = React.useState<string[]>([]);
  const handleOnChange = React.useCallback(
    (key) => {
      const items = expandedItems.includes(key)
        ? expandedItems.filter((i: string) => i !== key)
        : expandedItems.concat(key);

      setExpandedItems(items);
    },
    [expandedItems, setExpandedItems],
  );

  const isCollapsed = React.useMemo(
    () => expandedItems.length !== items.length,
    [expandedItems, items],
  );

  const collapseAll = React.useCallback(
    () => setExpandedItems([]),
    [setExpandedItems],
  );

  const expandAll = React.useCallback(
    () => setExpandedItems(items),
    [setExpandedItems, items],
  );

  // items might not be static, so we want to expand all when items change
  React.useEffect(() => expandAll(), [expandAll]);

  return {
    expandedItems,
    isCollapsed,
    expandAll,
    collapseAll,
    handleOnChange,
  };
};
